import { BottomSheet } from './BottomSheet';
import { ActionButton } from './ActionButton';
import React, { useState } from 'react';

import { 
  Pencil, Trash2, Plus, Eye, EyeOff, 
  Zap, FileText, Move 
} from 'lucide-react';

export function PPBottomSheet({ 
  objectNumber, 
  id,
  isEditable,
  isMoving: initialIsMoving,
  isSchemaActive: initialIsSchemaActive,
  onClose,
  onEdit,
  onDelete,
  onAddLine,
  onToggleSchema,
  onShowFiders,
  onPassport,
  onMovingChange
}) {

  const [isMoving, setIsMoving] = useState(initialIsMoving); 
  const [isSchemaActive, setIsSchemaActive] = useState(initialIsSchemaActive);

  const handleMovingChange = (e) => {
    setIsMoving(e.target.checked); // ← обновляем локально сразу
    onMovingChange(e); // ← вызываем внешний обработчик
  };

  const handleToggleSchema = () => {
    onToggleSchema();
    setIsSchemaActive(!isSchemaActive); // ← обновляем локально сразу
  };

  return (
    <BottomSheet 
      title={`${objectNumber}`} 
      onClose={onClose} 
      open={true}
      isEditable={isEditable}
      onDelete={onDelete}
    >
      
      {/* Сетка кнопок */}
      <div className="grid grid-cols-2 gap-3 mb-4">

        <ActionButton 
          label="Паспорт"
          icon={<FileText size={16} />}
          variant="primary"
          fullWidth={true}
          onClick={() => { onPassport(); /*onClose();*/ }}
        />

        <ActionButton 
          label={isSchemaActive ? 'Скрыть схему' : 'Показать схему'}
          icon={isSchemaActive ? <EyeOff size={16} /> : <Eye size={16} />}
          variant={isSchemaActive ? 'default' : 'primary'}
          onClick={handleToggleSchema}
        />

        <ActionButton 
          label="Фидеры"
          icon={<Zap size={16} />}
          variant="primary"
          onClick={() => { onShowFiders(); onClose(); }}
        />
        
        {isEditable && (
          <>
          <ActionButton 
            label="Редактировать" 
            icon={<Pencil size={16} />}
            onClick={() => { onEdit(); onClose(); }}
          />

          <ActionButton 
            label="Добавить линию"
            icon={<Plus size={16} />}
            onClick={() => { onAddLine(); onClose(); }}
          />
          </>
        )}

        
      </div>

      {/* Чекбокс перемещения */}
      {isEditable && (
  <div className="flex items-center justify-between py-3 border-t border-gray-100">
    <div className="flex items-center gap-2">
      <Move size={16} className="text-gray-400" />
      <label htmlFor="moving-switch" className="text-sm text-gray-600">
        Перемещение объектов
      </label>
    </div>
    
    {/* Switch */}
    <div 
      onClick={() => handleMovingChange({ target: { checked: !isMoving } })}
      className={`
        relative w-12 h-6 rounded-full cursor-pointer transition-colors duration-200
        ${isMoving ? 'bg-blue-500' : 'bg-gray-200'}
      `}
    >
      <div className={`
        absolute top-1 w-4 h-4 bg-white rounded-full shadow transition-transform duration-200
        ${isMoving ? 'translate-x-7' : 'translate-x-1'}
      `}/>
    </div>
  </div>
)}

    </BottomSheet>
  );
}